const quickSwitch = require('airship/widgets/recent-projects/quick-switch')
  .default

const reachProjectEl = document.querySelector('[rel=projects-search]')
const engageSwitcherEl = document.querySelector('[rel=app-search]')

quickSwitch(engageSwitcherEl || reachProjectEl)
